var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[(_vm.$can('change-setting', 'notification'))?_c('action-bar',[_c('router-link',{staticClass:"btn btn-success",attrs:{"to":"/news/create"}},[_vm._v(_vm._s(_vm.$t('newsletter.btn.add')))])],1):_vm._e(),_c('filter-bar'),_c('kt-datatable',_vm._b({},'kt-datatable',_vm.datatableProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }